// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url%28%23grain%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  padding-top: 120px;
  padding-bottom: 80px;
}

.hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
}

.hero-title {
  font-size: 2.8rem;
  font-weight: 800;
  margin-bottom: 16px;
  color: #2d3748;
  line-height: 1.15;
}

.hero-description {
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 24px;
}

.hero-cta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.hero-features {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.feature {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #2d3748;
}

.feature-icon {
  font-size: 1.5rem;
}

.hero-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-placeholder {
  width: 100%;
  max-width: 520px;
  height: 360px;
  background: linear-gradient(135deg, #9e2536 0%, #c73951 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 20px 40px rgba(158, 37, 54, 0.3);
  position: relative;
  overflow: hidden;
}

.image-placeholder::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.placeholder-content {
  text-align: center;
  color: white;
  z-index: 1;
  position: relative;
}

.placeholder-icon {
  font-size: 4rem;
  display: block;
  margin-bottom: 16px;
}

.placeholder-content p {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.placeholder-content small {
  opacity: 0.9;
  font-size: 0.9rem;
}

/* GPU Network Styles */
.gpu-network { 
  width: 100%; 
  max-width: 520px; 
  height: 400px; 
  background: linear-gradient(135deg, #fdf7f8 0%, #f0d1d6 100%);
  border-radius: 20px; 
  padding: 20px;
  position: relative;
  overflow: hidden;
  filter: blur(0px);
  transition: all 0.3s ease;
}

.gpu-network::before {
  content: '';
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(135deg, #fdf7f8 0%, #f0d1d6 100%);
  filter: blur(15px);
  z-index: -1;
  opacity: 0.7;
}

.gpu-network::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 25% 25%, rgba(158, 37, 54, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 75% 75%, rgba(199, 57, 81, 0.08) 0%, transparent 50%);
  z-index: 1;
}

.network-title {
  text-align: center;
  color: #4a5568;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 20px;
  z-index: 10;
  position: relative;
}

.gpu-cluster {
  position: relative;
  height: 300px;
  z-index: 5;
}

.gpu-node {
  position: absolute;
  width: 55px;
  height: 55px;
  background: linear-gradient(145deg, #ffffff 0%, #f0f4f8 50%, #e2e8f0 100%);
  border: 2px solid rgba(158, 37, 54, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 8px 16px rgba(158, 37, 54, 0.15),
    0 4px 8px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8),
    inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.4s ease;
  animation: nodePulse 4s ease-in-out infinite;
  z-index: 10;
  transform-style: preserve-3d;
}

.gpu-node:hover {
  transform: scale(1.15) translateZ(10px) rotateX(10deg) rotateY(10deg);
  box-shadow: 
    0 12px 24px rgba(158, 37, 54, 0.25),
    0 6px 12px rgba(0, 0, 0, 0.15),
    inset 0 2px 0 rgba(255, 255, 255, 0.9),
    inset 0 -2px 0 rgba(0, 0, 0, 0.15);
  border-color: rgba(158, 37, 54, 0.7);
}

.gpu-icon {
  font-size: 1.6rem;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
  animation: iconFloat 3s ease-in-out infinite;
  transform-style: preserve-3d;
}

/* GPU Node Positions - 8 nodes in a distributed pattern */
.gpu-node-1 { top: 30px; left: 60px; animation-delay: 0s; }
.gpu-node-2 { top: 30px; right: 60px; animation-delay: 0.4s; }
.gpu-node-3 { top: 120px; left: 20px; animation-delay: 0.8s; }
.gpu-node-4 { top: 120px; right: 20px; animation-delay: 1.2s; }
.gpu-node-5 { top: 210px; left: 80px; animation-delay: 1.6s; }
.gpu-node-6 { top: 210px; right: 80px; animation-delay: 2.0s; }
.gpu-node-7 { top: 80px; left: 200px; animation-delay: 2.4s; }
.gpu-node-8 { top: 160px; left: 200px; animation-delay: 2.8s; }

/* Connection Lines - forming a real network */
.connection-line {
  position: absolute;
  background: linear-gradient(90deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);
  border-radius: 1px;
  opacity: 0.7;
  animation: lineGlow 3s ease-in-out infinite;
  z-index: 5;
  box-shadow: 0 0 4px rgba(158, 37, 54, 0.3);
}

/* Horizontal connections */
.line-1 {
  /* Connect node-1 to node-2 */
  top: 57px;
  left: 115px;
  width: 290px;
  height: 2px;
  animation-delay: 0s;
}

.line-2 {
  /* Connect node-3 to node-4 */
  top: 147px;
  left: 75px;
  width: 370px;
  height: 2px;
  animation-delay: 0.8s;
}

.line-3 {
  /* Connect node-5 to node-6 */
  top: 237px;
  left: 135px;
  width: 290px;
  height: 2px;
  animation-delay: 1.6s;
}

.line-4 {
  /* Connect node-7 to node-8 */
  top: 147px;
  left: 227px;
  width: 2px;
  height: 70px;
  background: linear-gradient(180deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);
  animation-delay: 2.4s;
}

/* Vertical connections */
.line-5 {
  /* Connect node-1 to node-3 */
  top: 85px;
  left: 87px;
  width: 2px;
  height: 62px;
  background: linear-gradient(180deg, transparent 0%, rgba(199, 57, 81, 0.6) 50%, transparent 100%);
  animation-delay: 0.4s;
}

.line-6 {
  /* Connect node-2 to node-4 */
  top: 85px;
  right: 87px;
  width: 2px;
  height: 62px;
  background: linear-gradient(180deg, transparent 0%, rgba(199, 57, 81, 0.6) 50%, transparent 100%);
  animation-delay: 1.2s;
}

.line-7 {
  /* Connect node-3 to node-5 */
  top: 175px;
  left: 47px;
  width: 2px;
  height: 62px;
  background: linear-gradient(180deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);
  animation-delay: 2.0s;
}

.line-8 {
  /* Connect node-4 to node-6 */
  top: 175px;
  right: 47px;
  width: 2px;
  height: 62px;
  background: linear-gradient(180deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);
  animation-delay: 2.8s;
}

/* Data Particles */
.data-particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: radial-gradient(circle, #9e2536 0%, rgba(158, 37, 54, 0.9) 60%, transparent 100%);
  border-radius: 50%;
  box-shadow: 
    0 0 8px rgba(158, 37, 54, 0.8),
    0 0 4px rgba(255, 255, 255, 0.6);
  opacity: 0;
  z-index: 15;
}

.particle-1 {
  /* Flow along line-1 (node-1 to node-2) */
  top: 56px;
  left: 115px;
  animation: particleFlow1 3s ease-in-out infinite;
}

.particle-2 {
  /* Flow along line-2 (node-3 to node-4) */
  top: 146px;
  left: 75px;
  animation: particleFlow2 3s ease-in-out infinite 0.8s;
}

.particle-3 {
  /* Flow along line-3 (node-5 to node-6) */
  top: 236px;
  left: 135px;
  animation: particleFlow3 3s ease-in-out infinite 1.6s;
}

.particle-4 {
  /* Flow along line-5 (node-1 to node-3) */
  top: 85px;
  left: 86px;
  animation: particleFlow4 3s ease-in-out infinite 0.4s;
}

.particle-5 {
  /* Flow along line-6 (node-2 to node-4) */
  top: 85px;
  right: 88px;
  animation: particleFlow5 3s ease-in-out infinite 1.2s;
}

.particle-6 {
  /* Flow along line-7 (node-3 to node-5) */
  top: 175px;
  left: 46px;
  animation: particleFlow6 3s ease-in-out infinite 2.0s;
}

.particle-7 {
  /* Flow along line-8 (node-4 to node-6) */
  top: 175px;
  right: 48px;
  animation: particleFlow7 3s ease-in-out infinite 2.8s;
}

.particle-8 {
  /* Flow along line-4 (node-7 to node-8) */
  top: 147px;
  left: 226px;
  animation: particleFlow8 3s ease-in-out infinite 2.4s;
}

/* Network Info */
.network-info {
  position: absolute;
  bottom: 15px;
  left: 20px;
  right: 20px;
  display: flex;
  justify-content: space-around;
  z-index: 10;
}

.info-item {
  text-align: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 8px 12px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(158, 37, 54, 0.2);
}

.info-number {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  color: #9e2536;
}

.info-text {
  font-size: 0.7rem;
  color: #4a5568;
  opacity: 0.8;
}

/* Animations */
@keyframes nodePulse {
  0%, 100% { 
    opacity: 1; 
    transform: scale(1) translateZ(0);
    box-shadow: 
      0 8px 16px rgba(158, 37, 54, 0.15),
      0 4px 8px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.8),
      inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  }
  50% { 
    opacity: 0.9; 
    transform: scale(1.08) translateZ(5px);
    box-shadow: 
      0 12px 24px rgba(158, 37, 54, 0.2),
      0 6px 12px rgba(0, 0, 0, 0.15),
      inset 0 2px 0 rgba(255, 255, 255, 0.9),
      inset 0 -2px 0 rgba(0, 0, 0, 0.15);
  }
}

@keyframes iconFloat {
  0%, 100% { 
    transform: translateY(0) translateZ(0) rotateX(0deg); 
  }
  50% { 
    transform: translateY(-3px) translateZ(2px) rotateX(5deg); 
  }
}

@keyframes lineGlow {
  0%, 100% { 
    opacity: 0.4; 
    box-shadow: 0 0 4px rgba(158, 37, 54, 0.3);
  }
  50% { 
    opacity: 0.9; 
    box-shadow: 0 0 8px rgba(158, 37, 54, 0.6);
  }
}

@keyframes particleFlow1 {
  0% { opacity: 0; transform: translateX(0) scale(0.8); }
  20% { opacity: 1; transform: translateX(50px) scale(1); }
  80% { opacity: 1; transform: translateX(240px) scale(1); }
  100% { opacity: 0; transform: translateX(290px) scale(0.8); }
}

@keyframes particleFlow2 {
  0% { opacity: 0; transform: translateX(0) scale(0.8); }
  20% { opacity: 1; transform: translateX(80px) scale(1); }
  80% { opacity: 1; transform: translateX(290px) scale(1); }
  100% { opacity: 0; transform: translateX(370px) scale(0.8); }
}

@keyframes particleFlow3 {
  0% { opacity: 0; transform: translateX(0) scale(0.8); }
  20% { opacity: 1; transform: translateX(60px) scale(1); }
  80% { opacity: 1; transform: translateX(230px) scale(1); }
  100% { opacity: 0; transform: translateX(290px) scale(0.8); }
}

@keyframes particleFlow4 {
  0% { opacity: 0; transform: translateY(0) scale(0.8); }
  20% { opacity: 1; transform: translateY(15px) scale(1); }
  80% { opacity: 1; transform: translateY(47px) scale(1); }
  100% { opacity: 0; transform: translateY(62px) scale(0.8); }
}

@keyframes particleFlow5 {
  0% { opacity: 0; transform: translateY(0) scale(0.8); }
  20% { opacity: 1; transform: translateY(15px) scale(1); }
  80% { opacity: 1; transform: translateY(47px) scale(1); }
  100% { opacity: 0; transform: translateY(62px) scale(0.8); }
}

@keyframes particleFlow6 {
  0% { opacity: 0; transform: translateY(0) scale(0.8); }
  20% { opacity: 1; transform: translateY(15px) scale(1); }
  80% { opacity: 1; transform: translateY(47px) scale(1); }
  100% { opacity: 0; transform: translateY(62px) scale(0.8); }
}

@keyframes particleFlow7 {
  0% { opacity: 0; transform: translateY(0) scale(0.8); }
  20% { opacity: 1; transform: translateY(15px) scale(1); }
  80% { opacity: 1; transform: translateY(47px) scale(1); }
  100% { opacity: 0; transform: translateY(62px) scale(0.8); }
}

@keyframes particleFlow8 {
  0% { opacity: 0; transform: translateY(0) scale(0.8); }
  20% { opacity: 1; transform: translateY(20px) scale(1); }
  80% { opacity: 1; transform: translateY(50px) scale(1); }
  100% { opacity: 0; transform: translateY(70px) scale(0.8); }
}

@media (max-width: 900px) {
  .hero-content {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-description {
    font-size: 1rem;
  }
  
  .hero-features {
    gap: 16px;
  }
  
  .image-placeholder {
    height: 280px;
  }
  
  .gpu-network {
    height: 300px;
    max-width: 400px;
  }
  
  .gpu-node {
    width: 40px;
    height: 40px;
  }
  
  .gpu-icon {
    font-size: 1.4rem;
  }
  
  .info-number {
    font-size: 1rem;
  }
  
  .info-text {
    font-size: 0.6rem;
  }
  
  .network-title {
    font-size: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAyiB;AAC3iB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;mFAEiF;EACjF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;qCAImC;EACnC,yBAAyB;EACzB,4CAA4C;EAC5C,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,qEAAqE;EACrE;;;;sCAIoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA,0DAA0D;AAC1D,cAAc,SAAS,EAAE,UAAU,EAAE,mBAAmB,EAAE;AAC1D,cAAc,SAAS,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC7D,cAAc,UAAU,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC7D,cAAc,UAAU,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC9D,cAAc,UAAU,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC7D,cAAc,UAAU,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC9D,cAAc,SAAS,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC7D,cAAc,UAAU,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAE9D,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,gGAAgG;EAChG,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;EAC3C,UAAU;EACV,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,UAAU;EACV,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iGAAiG;EACjG,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ,iGAAiG;EACjG,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iGAAiG;EACjG,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,UAAU;EACV,UAAU;EACV,YAAY;EACZ,iGAAiG;EACjG,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iGAAiG;EACjG,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6FAA6F;EAC7F,kBAAkB;EAClB;;oCAEkC;EAClC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,SAAS;EACT,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,SAAS;EACT,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,WAAW;EACX,qDAAqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,iCAAiC;IACjC;;;;uCAImC;EACrC;EACA;IACE,YAAY;IACZ,sCAAsC;IACtC;;;;wCAIoC;EACtC;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,yDAAyD;EAC3D;AACF;;AAEA;EACE;IACE,YAAY;IACZ,0CAA0C;EAC5C;EACA;IACE,YAAY;IACZ,0CAA0C;EAC5C;AACF;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,qCAAqC,EAAE;EACzD,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,qCAAqC,EAAE;EACzD,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,qCAAqC,EAAE;EACzD,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA;EACE,KAAK,UAAU,EAAE,mCAAmC,EAAE;EACtD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,MAAM,UAAU,EAAE,oCAAoC,EAAE;EACxD,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".hero {\n  padding-top: 120px;\n  padding-bottom: 80px;\n}\n\n.hero-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: center;\n}\n\n.hero-title {\n  font-size: 2.8rem;\n  font-weight: 800;\n  margin-bottom: 16px;\n  color: #2d3748;\n  line-height: 1.15;\n}\n\n.hero-description {\n  font-size: 1.1rem;\n  color: #4a5568;\n  margin-bottom: 24px;\n}\n\n.hero-cta {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.hero-features {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.feature {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: #2d3748;\n}\n\n.feature-icon {\n  font-size: 1.5rem;\n}\n\n.hero-image {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.image-placeholder {\n  width: 100%;\n  max-width: 520px;\n  height: 360px;\n  background: linear-gradient(135deg, #9e2536 0%, #c73951 100%);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 20px 40px rgba(158, 37, 54, 0.3);\n  position: relative;\n  overflow: hidden;\n}\n\n.image-placeholder::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>');\n}\n\n.placeholder-content {\n  text-align: center;\n  color: white;\n  z-index: 1;\n  position: relative;\n}\n\n.placeholder-icon {\n  font-size: 4rem;\n  display: block;\n  margin-bottom: 16px;\n}\n\n.placeholder-content p {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.placeholder-content small {\n  opacity: 0.9;\n  font-size: 0.9rem;\n}\n\n/* GPU Network Styles */\n.gpu-network { \n  width: 100%; \n  max-width: 520px; \n  height: 400px; \n  background: linear-gradient(135deg, #fdf7f8 0%, #f0d1d6 100%);\n  border-radius: 20px; \n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n  filter: blur(0px);\n  transition: all 0.3s ease;\n}\n\n.gpu-network::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: -10px;\n  right: -10px;\n  bottom: -10px;\n  background: linear-gradient(135deg, #fdf7f8 0%, #f0d1d6 100%);\n  filter: blur(15px);\n  z-index: -1;\n  opacity: 0.7;\n}\n\n.gpu-network::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 25% 25%, rgba(158, 37, 54, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 75% 75%, rgba(199, 57, 81, 0.08) 0%, transparent 50%);\n  z-index: 1;\n}\n\n.network-title {\n  text-align: center;\n  color: #4a5568;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n  z-index: 10;\n  position: relative;\n}\n\n.gpu-cluster {\n  position: relative;\n  height: 300px;\n  z-index: 5;\n}\n\n.gpu-node {\n  position: absolute;\n  width: 55px;\n  height: 55px;\n  background: linear-gradient(145deg, #ffffff 0%, #f0f4f8 50%, #e2e8f0 100%);\n  border: 2px solid rgba(158, 37, 54, 0.4);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: \n    0 8px 16px rgba(158, 37, 54, 0.15),\n    0 4px 8px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.1);\n  transition: all 0.4s ease;\n  animation: nodePulse 4s ease-in-out infinite;\n  z-index: 10;\n  transform-style: preserve-3d;\n}\n\n.gpu-node:hover {\n  transform: scale(1.15) translateZ(10px) rotateX(10deg) rotateY(10deg);\n  box-shadow: \n    0 12px 24px rgba(158, 37, 54, 0.25),\n    0 6px 12px rgba(0, 0, 0, 0.15),\n    inset 0 2px 0 rgba(255, 255, 255, 0.9),\n    inset 0 -2px 0 rgba(0, 0, 0, 0.15);\n  border-color: rgba(158, 37, 54, 0.7);\n}\n\n.gpu-icon {\n  font-size: 1.6rem;\n  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));\n  animation: iconFloat 3s ease-in-out infinite;\n  transform-style: preserve-3d;\n}\n\n/* GPU Node Positions - 8 nodes in a distributed pattern */\n.gpu-node-1 { top: 30px; left: 60px; animation-delay: 0s; }\n.gpu-node-2 { top: 30px; right: 60px; animation-delay: 0.4s; }\n.gpu-node-3 { top: 120px; left: 20px; animation-delay: 0.8s; }\n.gpu-node-4 { top: 120px; right: 20px; animation-delay: 1.2s; }\n.gpu-node-5 { top: 210px; left: 80px; animation-delay: 1.6s; }\n.gpu-node-6 { top: 210px; right: 80px; animation-delay: 2.0s; }\n.gpu-node-7 { top: 80px; left: 200px; animation-delay: 2.4s; }\n.gpu-node-8 { top: 160px; left: 200px; animation-delay: 2.8s; }\n\n/* Connection Lines - forming a real network */\n.connection-line {\n  position: absolute;\n  background: linear-gradient(90deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);\n  border-radius: 1px;\n  opacity: 0.7;\n  animation: lineGlow 3s ease-in-out infinite;\n  z-index: 5;\n  box-shadow: 0 0 4px rgba(158, 37, 54, 0.3);\n}\n\n/* Horizontal connections */\n.line-1 {\n  /* Connect node-1 to node-2 */\n  top: 57px;\n  left: 115px;\n  width: 290px;\n  height: 2px;\n  animation-delay: 0s;\n}\n\n.line-2 {\n  /* Connect node-3 to node-4 */\n  top: 147px;\n  left: 75px;\n  width: 370px;\n  height: 2px;\n  animation-delay: 0.8s;\n}\n\n.line-3 {\n  /* Connect node-5 to node-6 */\n  top: 237px;\n  left: 135px;\n  width: 290px;\n  height: 2px;\n  animation-delay: 1.6s;\n}\n\n.line-4 {\n  /* Connect node-7 to node-8 */\n  top: 147px;\n  left: 227px;\n  width: 2px;\n  height: 70px;\n  background: linear-gradient(180deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);\n  animation-delay: 2.4s;\n}\n\n/* Vertical connections */\n.line-5 {\n  /* Connect node-1 to node-3 */\n  top: 85px;\n  left: 87px;\n  width: 2px;\n  height: 62px;\n  background: linear-gradient(180deg, transparent 0%, rgba(199, 57, 81, 0.6) 50%, transparent 100%);\n  animation-delay: 0.4s;\n}\n\n.line-6 {\n  /* Connect node-2 to node-4 */\n  top: 85px;\n  right: 87px;\n  width: 2px;\n  height: 62px;\n  background: linear-gradient(180deg, transparent 0%, rgba(199, 57, 81, 0.6) 50%, transparent 100%);\n  animation-delay: 1.2s;\n}\n\n.line-7 {\n  /* Connect node-3 to node-5 */\n  top: 175px;\n  left: 47px;\n  width: 2px;\n  height: 62px;\n  background: linear-gradient(180deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);\n  animation-delay: 2.0s;\n}\n\n.line-8 {\n  /* Connect node-4 to node-6 */\n  top: 175px;\n  right: 47px;\n  width: 2px;\n  height: 62px;\n  background: linear-gradient(180deg, transparent 0%, rgba(158, 37, 54, 0.6) 50%, transparent 100%);\n  animation-delay: 2.8s;\n}\n\n/* Data Particles */\n.data-particle {\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  background: radial-gradient(circle, #9e2536 0%, rgba(158, 37, 54, 0.9) 60%, transparent 100%);\n  border-radius: 50%;\n  box-shadow: \n    0 0 8px rgba(158, 37, 54, 0.8),\n    0 0 4px rgba(255, 255, 255, 0.6);\n  opacity: 0;\n  z-index: 15;\n}\n\n.particle-1 {\n  /* Flow along line-1 (node-1 to node-2) */\n  top: 56px;\n  left: 115px;\n  animation: particleFlow1 3s ease-in-out infinite;\n}\n\n.particle-2 {\n  /* Flow along line-2 (node-3 to node-4) */\n  top: 146px;\n  left: 75px;\n  animation: particleFlow2 3s ease-in-out infinite 0.8s;\n}\n\n.particle-3 {\n  /* Flow along line-3 (node-5 to node-6) */\n  top: 236px;\n  left: 135px;\n  animation: particleFlow3 3s ease-in-out infinite 1.6s;\n}\n\n.particle-4 {\n  /* Flow along line-5 (node-1 to node-3) */\n  top: 85px;\n  left: 86px;\n  animation: particleFlow4 3s ease-in-out infinite 0.4s;\n}\n\n.particle-5 {\n  /* Flow along line-6 (node-2 to node-4) */\n  top: 85px;\n  right: 88px;\n  animation: particleFlow5 3s ease-in-out infinite 1.2s;\n}\n\n.particle-6 {\n  /* Flow along line-7 (node-3 to node-5) */\n  top: 175px;\n  left: 46px;\n  animation: particleFlow6 3s ease-in-out infinite 2.0s;\n}\n\n.particle-7 {\n  /* Flow along line-8 (node-4 to node-6) */\n  top: 175px;\n  right: 48px;\n  animation: particleFlow7 3s ease-in-out infinite 2.8s;\n}\n\n.particle-8 {\n  /* Flow along line-4 (node-7 to node-8) */\n  top: 147px;\n  left: 226px;\n  animation: particleFlow8 3s ease-in-out infinite 2.4s;\n}\n\n/* Network Info */\n.network-info {\n  position: absolute;\n  bottom: 15px;\n  left: 20px;\n  right: 20px;\n  display: flex;\n  justify-content: space-around;\n  z-index: 10;\n}\n\n.info-item {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  padding: 8px 12px;\n  backdrop-filter: blur(5px);\n  border: 1px solid rgba(158, 37, 54, 0.2);\n}\n\n.info-number {\n  display: block;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #9e2536;\n}\n\n.info-text {\n  font-size: 0.7rem;\n  color: #4a5568;\n  opacity: 0.8;\n}\n\n/* Animations */\n@keyframes nodePulse {\n  0%, 100% { \n    opacity: 1; \n    transform: scale(1) translateZ(0);\n    box-shadow: \n      0 8px 16px rgba(158, 37, 54, 0.15),\n      0 4px 8px rgba(0, 0, 0, 0.1),\n      inset 0 1px 0 rgba(255, 255, 255, 0.8),\n      inset 0 -1px 0 rgba(0, 0, 0, 0.1);\n  }\n  50% { \n    opacity: 0.9; \n    transform: scale(1.08) translateZ(5px);\n    box-shadow: \n      0 12px 24px rgba(158, 37, 54, 0.2),\n      0 6px 12px rgba(0, 0, 0, 0.15),\n      inset 0 2px 0 rgba(255, 255, 255, 0.9),\n      inset 0 -2px 0 rgba(0, 0, 0, 0.15);\n  }\n}\n\n@keyframes iconFloat {\n  0%, 100% { \n    transform: translateY(0) translateZ(0) rotateX(0deg); \n  }\n  50% { \n    transform: translateY(-3px) translateZ(2px) rotateX(5deg); \n  }\n}\n\n@keyframes lineGlow {\n  0%, 100% { \n    opacity: 0.4; \n    box-shadow: 0 0 4px rgba(158, 37, 54, 0.3);\n  }\n  50% { \n    opacity: 0.9; \n    box-shadow: 0 0 8px rgba(158, 37, 54, 0.6);\n  }\n}\n\n@keyframes particleFlow1 {\n  0% { opacity: 0; transform: translateX(0) scale(0.8); }\n  20% { opacity: 1; transform: translateX(50px) scale(1); }\n  80% { opacity: 1; transform: translateX(240px) scale(1); }\n  100% { opacity: 0; transform: translateX(290px) scale(0.8); }\n}\n\n@keyframes particleFlow2 {\n  0% { opacity: 0; transform: translateX(0) scale(0.8); }\n  20% { opacity: 1; transform: translateX(80px) scale(1); }\n  80% { opacity: 1; transform: translateX(290px) scale(1); }\n  100% { opacity: 0; transform: translateX(370px) scale(0.8); }\n}\n\n@keyframes particleFlow3 {\n  0% { opacity: 0; transform: translateX(0) scale(0.8); }\n  20% { opacity: 1; transform: translateX(60px) scale(1); }\n  80% { opacity: 1; transform: translateX(230px) scale(1); }\n  100% { opacity: 0; transform: translateX(290px) scale(0.8); }\n}\n\n@keyframes particleFlow4 {\n  0% { opacity: 0; transform: translateY(0) scale(0.8); }\n  20% { opacity: 1; transform: translateY(15px) scale(1); }\n  80% { opacity: 1; transform: translateY(47px) scale(1); }\n  100% { opacity: 0; transform: translateY(62px) scale(0.8); }\n}\n\n@keyframes particleFlow5 {\n  0% { opacity: 0; transform: translateY(0) scale(0.8); }\n  20% { opacity: 1; transform: translateY(15px) scale(1); }\n  80% { opacity: 1; transform: translateY(47px) scale(1); }\n  100% { opacity: 0; transform: translateY(62px) scale(0.8); }\n}\n\n@keyframes particleFlow6 {\n  0% { opacity: 0; transform: translateY(0) scale(0.8); }\n  20% { opacity: 1; transform: translateY(15px) scale(1); }\n  80% { opacity: 1; transform: translateY(47px) scale(1); }\n  100% { opacity: 0; transform: translateY(62px) scale(0.8); }\n}\n\n@keyframes particleFlow7 {\n  0% { opacity: 0; transform: translateY(0) scale(0.8); }\n  20% { opacity: 1; transform: translateY(15px) scale(1); }\n  80% { opacity: 1; transform: translateY(47px) scale(1); }\n  100% { opacity: 0; transform: translateY(62px) scale(0.8); }\n}\n\n@keyframes particleFlow8 {\n  0% { opacity: 0; transform: translateY(0) scale(0.8); }\n  20% { opacity: 1; transform: translateY(20px) scale(1); }\n  80% { opacity: 1; transform: translateY(50px) scale(1); }\n  100% { opacity: 0; transform: translateY(70px) scale(0.8); }\n}\n\n@media (max-width: 900px) {\n  .hero-content {\n    grid-template-columns: 1fr;\n    gap: 36px;\n  }\n  \n  .hero-title {\n    font-size: 2rem;\n  }\n  \n  .hero-description {\n    font-size: 1rem;\n  }\n  \n  .hero-features {\n    gap: 16px;\n  }\n  \n  .image-placeholder {\n    height: 280px;\n  }\n  \n  .gpu-network {\n    height: 300px;\n    max-width: 400px;\n  }\n  \n  .gpu-node {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .gpu-icon {\n    font-size: 1.4rem;\n  }\n  \n  .info-number {\n    font-size: 1rem;\n  }\n  \n  .info-text {\n    font-size: 0.6rem;\n  }\n  \n  .network-title {\n    font-size: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
